import { Box } from "@mui/material";

import StickyScroll from "../../components/ui/sticky-scroll-reveal";

import DemoVideoMp4 from "../../assets/videos/demo-video.mp4";
import AnalyticsAndHighlightImg from "../../../../assets/images/Home/AnalyticsAndHighlight.png";
import CommunicationAndAnnouncementsImg from "../../../../assets/images/Home/CommunicationAndAnnouncements.png";
import EmergingTalentsImg from "../../../../assets/images/Home/EmergingTalents.png";
import GlobalNetworkImg from "../../../../assets/images/Home/GlobalNetwork.png";
import StreamlinedFootballEventManagementImg from "../../../../assets/images/Home/StreamlinedFootballEventManagement.png";

const StickyScrollRevealDemo = () => {
  const content = [
    {
      title: "Collaborative Editing",
      description:
        "Work together in real time with your team, clients, and stakeholders. Collaborate on documents, share ideas, and make decisions faster. Never miss a beat with synchronous editing and instant updates.",
      content: (
        <Box
          sx={{
            display: "flex",
            height: "100%",
            width: "100%",
          }}
          component="video"
          autoPlay
          loop
          muted
          playsInline
          src={DemoVideoMp4}
        >
          <source src={DemoVideoMp4} type="video/mp4" />
          {/* <source src={DemoVideoWebm} type="video/webm" /> */}
        </Box>
      ),
    },
    {
      title: "Analytics and Insights",
      description:
        "Gain valuable insights into your football entity's performance with our analytics dashboard. Track key metrics such as fan engagement, viewership, and where your followers are coming from within Goalngo.",
      content: (
        <Box
          component="img"
          src={AnalyticsAndHighlightImg}
          alt="Analytics and Insights"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ),
    },
    {
      title: "Emerging Talent Scouting",
      description:
        "Discover and recruit global verified & emerging talent with our scouting tools. Access detailed player profiles, endorsements, and personal football videos and posts.",
      content: (
        <Box
          component="img"
          src={EmergingTalentsImg}
          alt="Emerging Talent Scouting"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ),
    },
    {
      title: "Global Network Building",
      description:
        "Build your global football network and boost your club's visibility with our GoReach engine. Gain more football followers & fans around the world.",
      content: (
        <Box
          component="img"
          src={GlobalNetworkImg}
          alt="Global Network Building"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ),
    },
    {
      title: "Effortless Communication & announcements",
      description:
        "Easily communicate and post updates to different teams and members using our chat and posting features.",
      content: (
        <Box
          component="img"
          src={CommunicationAndAnnouncementsImg}
          alt="Effortless Communication & announcements"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ),
    },
    {
      title: "Streamlined Football Event Management",
      description:
        "Manage your football events, including matches and trainings, effortlessly with our integrated calendar.",
      content: (
        <Box
          component="img"
          src={StreamlinedFootballEventManagementImg}
          alt="Streamlined Football Event Management"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", py: 4 }}>
      <StickyScroll content={content} />
    </Box>
  );
};

export default StickyScrollRevealDemo;
